const radioBoxesGroups = document.querySelectorAll<HTMLElement>('.g-radio-boxes');

radioBoxesGroups.forEach(group => {
  const showMoreButton = group.querySelector<HTMLElement>('.g-radio-boxes__show-more');

  showMoreButton?.addEventListener('click', (e) => {
    e.preventDefault();
    group.classList.toggle('--closed');
  })
})
